import { format } from 'date-fns'
import { ja } from 'date-fns/locale'
import { parseDate } from '../parseDate'

type Options = {
  week?: boolean | 'short' | 'long'
  short?: boolean
}

export const dateToStringInJa = (dateStr: string, options?: Options): string => {
  const date = parseDate(dateStr)
  if (!date) {
    throw new Error('Invalid date string')
  }
  return format(
    date,
    `${options?.short ? '' : 'yyyy年'}M月d日${!options?.week ? '' : options.week === 'long' ? 'eee曜日' : ' (eee)'}`,
    { locale: ja },
  )
}
